import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  inquiries: "Inquiry.Inquiry",
  list: "Inquiry.Inquiries",
  new: "Inquiry.InquiryNew",
  base: "Inquiry.InquiryBase",
  view: "Inquiry.InquiryView,",
  notes: "Inquiry.InquiryNotes",
  noteEdit: "Inquiry.InquiryNoteEdit",
  noteNew: "Inquiry.InquiryNoteNew",
  edit: "Inquiry.InquiryEdit",
  editStatus: "Inquiry.InquiryEditStatus",
  editPriority: "Inquiry.InquiryEditPriority",
  documents: "Inquiry.InquiryDocuments",
  documentEdit: "Inquiry.InquiryDocumentEdit",
  documentNew: "Inquiry.InquiryDocumentNew",
  audit: "Inquiry.InquiryAudit",
};

export { names as InquiryRouteNames };

const InquiryRoutes: RouterOptions["routes"] = [
  {
    path: "/inquiries",
    name: names.inquiries,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Inquiries",
        },
        component: () => import("@/views/inquiry/InquiryList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/inquiry/InquiryBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Inquiry New", isNew: true },
            component: () => import("@/views/inquiry/InquiryEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/inquiry/InquiryBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Inquiry View" },
            component: () => import("@/views/inquiry/InquiryView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Inquiry Edit", isForm: true },
            component: () => import("@/views/inquiry/InquiryEdit.vue"),
          },
          {
            path: "editStatus",
            name: names.editStatus,
            meta: { title: "Inquiry Status Edit", isForm: true },
            component: () => import("@/views/inquiry/InquiryStatusEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Inquiry Notes" },
            component: {
              render: () => <EntityNotes idField="inquiryId" routeNamePrefix="Inquiry.InquiryNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Inquiry Note Edit", isForm: true },
            component: () => import("@/views/inquiry/InquiryNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Inquiry Note New", isForm: true },
            component: () => import("@/views/inquiry/InquiryNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Inquiry Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="inquiry" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Inquiry Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="inquiry" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Inquiry Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="inquiry" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Inquiry Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Inquiry" />,
            },
          },
        ],
      },
    ],
  },
];
export default InquiryRoutes;
